<div class="bv-security-two-factor">
  <h1 class="bv-security-page__title">{{ "twoStepLogin" | i18n }}</h1>
  <p class="bv-security-page__desc">{{ "twoStepLoginDesc" | i18n }}</p>

  @if (showRecoveryWarning) {
    <div class="bv-security-warning-banner bv-security-two-factor__warning" role="alert">
      <bit-icon name="bwi-exclamation-triangle" class="bv-security-warning-banner__icon" />
      <div class="bv-security-warning-banner__content">
        <p class="bv-security-warning-banner__title">{{ "warning" | i18n }}</p>
        <p class="bv-security-warning-banner__message">{{ recoveryCodeWarningMessage }}</p>
      </div>
      <button
        type="button"
        bitIconButton="bwi-close"
        buttonType="subtleGhost"
        size="small"
        class="bv-security-warning-banner__close"
        [label]="'close' | i18n"
        (click)="showRecoveryWarning = false"
      ></button>
    </div>
  }

  <button
    type="button"
    bitButton
    buttonType="secondary"
    class="bv-security-outline-btn bv-security-two-factor__recovery-btn"
    (click)="recoveryCode()"
  >
    {{ "viewRecoveryCode" | i18n }}
  </button>

  <h2 class="bv-security-section-title">
    {{ "providers" | i18n }}
    @if (loading) {
      <bit-icon
        name="bwi-spinner"
        class="bwi-spin bwi-fw tw-text-muted tw-ml-2"
        [ariaLabel]="'loading' | i18n"
      ></bit-icon>
    }
  </h2>

  @if (showPolicyWarning) {
    <bit-callout type="warning">{{ "twoStepLoginPolicyUserWarning" | i18n }}</bit-callout>
  }

  <div class="bv-security-provider-list" [attr.aria-label]="'providers' | i18n">
    @for (p of providers; track p.type) {
      <div class="bv-security-provider-row">
        <div class="bv-security-provider-row__icon">
          <app-bv-two-factor-provider-icon [provider]="p.type" [name]="p.name" />
        </div>

        <div class="bv-security-provider-row__content">
          <div class="bv-security-provider-row__title">
            <span>{{ p.name }}</span>
            @if (p.enabled) {
              <bit-icon
                name="bwi-check"
                class="tw-text-success-600 bwi-fw tw-ml-2"
                [ariaLabel]="'enabled' | i18n"
              ></bit-icon>
            }
            @if (p.premium) {
              <app-premium-badge class="tw-ml-2"></app-premium-badge>
            }
          </div>
          <p class="bv-security-provider-row__description">{{ p.description }}</p>
        </div>

        <div class="bv-security-provider-row__action">
          @if (p.premium && p.enabled && !(canAccessPremium$ | async)) {
            <button
              type="button"
              bitButton
              buttonType="danger"
              (click)="disablePremium2faTypeForNonPremiumUser(p.type)"
            >
              {{ "disable" | i18n }}
            </button>
          } @else {
            <button
              type="button"
              bitButton
              buttonType="secondary"
              class="bv-security-outline-btn"
              [disabled]="!(canAccessPremium$ | async) && p.premium"
              (click)="manage(p.type)"
            >
              {{ "manage" | i18n }}
            </button>
          }
        </div>
      </div>
    }
  </div>
</div>
